import { C } from "../lib/theme";

export function KapioLogo({ size = 30 }) {
  const s = size;
  return (
    <svg width={s} height={s} viewBox={`0 0 ${s} ${s}`}>
      <rect width={s} height={s} rx={s * 0.22} fill={C.hunter} />
      <rect x={s * 0.25} y={s * 0.15} width={s * 0.09} height={s * 0.7} rx={s * 0.045} fill={C.dust} />
      <rect x={s * 0.4} y={s * 0.15} width={s * 0.4} height={s * 0.32} rx={s * 0.08} fill={C.dust} opacity="0.5" />
      <rect x={s * 0.4} y={s * 0.53} width={s * 0.4} height={s * 0.32} rx={s * 0.08} fill={C.dust} />
    </svg>
  );
}
